import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

// Initialize EmailJS
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    projectType: '',
    message: '',
    budget: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, '#contact-form');

      setSubmitStatus({ type: 'success', message: 'Thank you for your message! We\'ll get back to you soon.' });
      setFormData({
        name: '',
        email: '',
        projectType: '',
        message: '',
        budget: ''
      });
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again or contact us directly.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1 className="hero-title">
          <span className="gradient-text">Let's Talk</span>
        </h1>
        <p className="tagline">
          Ready to elevate your digital presence? Drop us a message and let's create something extraordinary.
        </p>
      </section>

      <section className="contact-content">
        <div className="contact-info glass">
          <div className="contact-method">
            <h3 className="contact-method-title">Email</h3>
            <p className="contact-method-text">
              <a href="mailto:digitalavatar.space@gmail.com">digitalavatar.space@gmail.com</a>
            </p>
          </div>

          <div className="contact-method">
            <h3 className="contact-method-title">Live Chat</h3>
            <p className="contact-method-text">
              Available Mon-Fri, 9AM-6PM EST<br />
              Instant responses for quick questions
            </p>
          </div>

          <div className="contact-method">
            <h3 className="contact-method-title">Global Reach</h3>
            <p className="contact-method-text">
              Working with clients worldwide<br />
              Time zones are never a problem
            </p>
          </div>

          <div className="contact-method">
            <h3 className="contact-method-title">Response Time</h3>
            <p className="contact-method-text">
              We respond within 24 hours<br />
              Usually much faster
            </p>
          </div>
        </div>

        <div className="contact-form glass">
          {submitStatus && (
            <div className={`submit-message ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}
          <form id="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Your Name</label>
              <input
                type="text"
                name="name"
                className="form-input"
                placeholder="John Doe"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="john@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Project Type</label>
              <input
                type="text"
                name="projectType"
                className="form-input"
                placeholder="E.g., E-commerce website, Portfolio, Web App"
                value={formData.projectType}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Tell Us About Your Project</label>
              <textarea
                name="message"
                className="form-textarea"
                placeholder="Share your vision, goals, timeline, and any specific requirements..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="form-button" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </section>

      <section className="section" style={{ padding: '6rem 2rem' }}>
        <h2 className="section-title">
          What Happens <span className="gradient-text">Next</span>?
        </h2>

        <div className="about-grid">
          <div className="value-card glass">
            <h3 className="value-title">We Review</h3>
            <p className="value-text">
              We carefully review your project details and prepare initial thoughts and questions.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Discovery Call</h3>
            <p className="value-text">
              We schedule a call to dive deep into your vision, goals, and requirements.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Proposal</h3>
            <p className="value-text">
              You receive a detailed proposal with timeline, deliverables, and transparent pricing.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Creation</h3>
            <p className="value-text">
              We bring your vision to life with regular check-ins and collaborative refinement.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Launch</h3>
            <p className="value-text">
              Your site goes live with full support, training, and documentation.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Growth</h3>
            <p className="value-text">
              Ongoing support, optimization, and enhancements as your needs evolve.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
